export default __webpack_public_path__ + "static/media/2.35a33e6a.svg";